var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jm-page" },
    [
      _c("div", { staticClass: "jm-back", on: { click: _vm.back } }, [
        _c("i", { staticClass: "el-icon-arrow-left" }),
        _vm._v(" "),
        _c("div", { staticClass: "jm-back-text" }, [_vm._v("返回")])
      ]),
      _vm._v(" "),
      !_vm.settings.isStart
        ? _c(
            "div",
            { staticClass: "jm-spacer" },
            [
              _c("span", [_vm._v("每10分钟进线 3 名客户")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.productModal.handleStart()
                    }
                  }
                },
                [_vm._v("开始")]
              ),
              _vm._v(" "),
              _vm._m(0)
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "jm-spacer" },
            [
              _vm._m(1),
              _vm._v(" "),
              _vm.hasProducts
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.productModal.showProducts()
                        }
                      }
                    },
                    [_vm._v("产品须知")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    gap: "10px"
                  }
                },
                [
                  _c(
                    "span",
                    { staticStyle: { "font-weight": "bold", color: "black" } },
                    [_vm._v("推荐回复")]
                  ),
                  _vm._v(" "),
                  _c("el-switch", {
                    on: { change: _vm.changeRecommendReply },
                    model: {
                      value: _vm.settings.isRecommendReply,
                      callback: function($$v) {
                        _vm.$set(_vm.settings, "isRecommendReply", $$v)
                      },
                      expression: "settings.isRecommendReply"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "20px",
                    "font-weight": "bold",
                    color: "black"
                  }
                },
                [_vm._v(_vm._s(_vm.formattedTime))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "warning" }, on: { click: _vm.stopTrain } },
                [_vm._v("退出")]
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "回复数：" +
                    _vm._s(_vm.totalReplyCount) +
                    " 打字速度：" +
                    _vm._s(_vm.typingSpeedWPM) +
                    "字/分钟 "
                ),
                _c("br"),
                _vm._v(
                  "首次响应时间：" +
                    _vm._s(_vm.firstResponseAvgSec) +
                    "秒 平均响应时间：" +
                    _vm._s(_vm.avgResponseSec) +
                    "秒"
                )
              ])
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.settings.pageType == 1 || _vm.settings.pageType == 2,
              expression: "settings.pageType == 1 || settings.pageType == 2"
            }
          ],
          staticClass: "jm-container"
        },
        [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.settings.pageType == 1,
                expression: "settings.pageType == 1"
              }
            ],
            staticClass: "jm-bg",
            attrs: {
              src: require("@/assets/images/jingmai/dd_reply.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.settings.pageType == 2,
                expression: "settings.pageType == 2"
              }
            ],
            staticClass: "jm-bg",
            attrs: {
              src: require("@/assets/images/jingmai/dd_order.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "jm-content" },
            [
              _c("div", { staticClass: "shop-name" }, [
                _vm._v("飞鸽对练实操店铺")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "xiaoer-name" }, [_vm._v("练习账号")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "status-select",
                  class: _vm.getStatusClass(_vm.settings.onlineStatus),
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.settings.onlineStatus,
                    callback: function($$v) {
                      _vm.$set(_vm.settings, "onlineStatus", $$v)
                    },
                    expression: "settings.onlineStatus"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "接待", value: "1" } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "小休", value: "2" } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "挂起", value: "3" } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "train-session-list" },
                _vm._l(_vm.settings.trainSession || [], function(s) {
                  return _c(
                    "div",
                    {
                      key: s.id || s.veruser,
                      staticClass: "ts-item",
                      class: {
                        current: s.isCurrent,
                        replied: !s.isCurrent && !s.didReply
                      },
                      on: {
                        click: function($event) {
                          return _vm.selectSession(s)
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "ts-avatar",
                        attrs: {
                          src: require("@/assets/images/jingmai/monitorPhoto.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "ts-name" }, [
                        _vm._v(_vm._s(s.veruser))
                      ])
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.currentSession
                ? _c("div", { staticClass: "chat-msg-header" }, [
                    _c("img", {
                      staticClass: "cmh-avatar",
                      attrs: {
                        src: require("@/assets/images/jingmai/monitorPhoto.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "cmh-name",
                        attrs: { title: _vm.currentSession.veruser }
                      },
                      [_vm._v(_vm._s(_vm.currentSession.veruser))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticStyle: { flex: "1" } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "cmh-actions" },
                      [
                        _c("i", { staticClass: "el-icon-star-off cmh-action" }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "el-icon-warning-outline cmh-action"
                        }),
                        _vm._v(" "),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "bottom-start",
                              width: "300",
                              trigger: "click",
                              "popper-class": "transfer-pop"
                            },
                            model: {
                              value: _vm.transferPopoverVisible,
                              callback: function($$v) {
                                _vm.transferPopoverVisible = $$v
                              },
                              expression: "transferPopoverVisible"
                            }
                          },
                          [
                            _c("div", { staticClass: "transfer-pop" }, [
                              _c("div", { staticClass: "tp-tabs" }, [
                                _c("div", { staticClass: "tp-tab active" }, [
                                  _vm._v("转接到客服")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "tp-tab" }, [
                                  _vm._v("转接到组")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "tp-search" },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled: "",
                                      size: "small",
                                      placeholder: "请输入在线客服昵称",
                                      "suffix-icon": "el-icon-search"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "tp-list" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "tp-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.saveActionRecord(
                                          "TRANSFER_AFTER_SALE",
                                          "已转接给售后客服:001"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "tp-dot online"
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "tp-name" }, [
                                      _vm._v("售后客服001")
                                    ])
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "cmh-icon-wrap",
                                attrs: { slot: "reference" },
                                slot: "reference"
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-user cmh-action"
                                }),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "cmh-badge",
                                  attrs: {
                                    src: require("@/assets/images/jingmai/zhihuan.png")
                                  }
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "关闭会话",
                              placement: "top",
                              effect: "dark"
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-switch-button cmh-action",
                              on: { click: _vm.closeSession }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.currentSession
                ? _c(
                    "div",
                    { ref: "chatContent", staticClass: "chat-msg-content" },
                    [
                      _c(
                        "div",
                        { staticClass: "chat-msg-list" },
                        _vm._l(_vm.currentMessages, function(msg, idx) {
                          return _c(
                            "div",
                            { key: msg.id || idx, staticClass: "msg-item" },
                            [
                              _c("img", {
                                staticClass: "msg-avatar",
                                attrs: {
                                  src: require("@/assets/images/jingmai/monitorPhoto.png")
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "msg-main" },
                                [
                                  _c("div", { staticClass: "msg-header" }, [
                                    _c("span", { staticClass: "msg-name" }, [
                                      _vm._v(_vm._s(msg.fromName || "对方"))
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "msg-time" }, [
                                      _vm._v(
                                        _vm._s(_vm.formatMsgTime(msg.sendTime))
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  msg.questionType === "卡片" &&
                                  _vm.findOrderById(msg.questionOrderId)
                                    ? _c("order-msg-card", {
                                        attrs: {
                                          order: _vm.findOrderById(
                                            msg.questionOrderId
                                          ),
                                          platform: "douyin"
                                        }
                                      })
                                    : [
                                        _c("div", {
                                          staticClass: "msg-text",
                                          domProps: {
                                            innerHTML: _vm._s(msg.question)
                                          }
                                        }),
                                        _vm._v(" "),
                                        msg.questionImg
                                          ? _c("img", {
                                              staticClass: "msg-image",
                                              attrs: { src: msg.questionImg }
                                            })
                                          : _vm._e()
                                      ],
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ref-title",
                                      on: {
                                        click: function($event) {
                                          msg.fold = !msg.fold
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          msg.fold
                                            ? "查看参考答案"
                                            : "收起参考答案"
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !msg.fold
                                    ? _c(
                                        "div",
                                        { staticClass: "msg-reference" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "ref-label" },
                                            [_vm._v("参考回复：")]
                                          ),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "ref-body",
                                            domProps: {
                                              innerHTML: _vm._s(msg.answer)
                                            },
                                            on: {
                                              copy: function($event) {
                                                $event.preventDefault()
                                              },
                                              cut: function($event) {
                                                $event.preventDefault()
                                              },
                                              contextmenu: function($event) {
                                                $event.preventDefault()
                                              },
                                              selectstart: function($event) {
                                                $event.preventDefault()
                                              },
                                              dragstart: function($event) {
                                                $event.preventDefault()
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  (msg.replyList || []).length
                                    ? _c(
                                        "div",
                                        { staticClass: "reply-list" },
                                        _vm._l(msg.replyList, function(
                                          rep,
                                          rIdx
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: rep.id || rIdx,
                                              staticClass: "reply-item"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "msg-header right"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "msg-time" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formatMsgTime(
                                                            rep.sendTime
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("img", {
                                                    staticClass: "msg-avatar",
                                                    attrs: {
                                                      src: require("@/assets/images/jingmai/monitorPhoto.png")
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "msg-text msg-rich"
                                                },
                                                [
                                                  _vm._l(
                                                    _vm.parseContent(
                                                      rep.content
                                                    ),
                                                    function(node, nIdx) {
                                                      return [
                                                        node.type === "img"
                                                          ? _c("img", {
                                                              key:
                                                                "img-" + nIdx,
                                                              staticClass:
                                                                "msg-image",
                                                              attrs: {
                                                                src: node.src
                                                              }
                                                            })
                                                          : _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "txt-" + nIdx,
                                                                staticStyle: {
                                                                  display:
                                                                    "block"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    node.text
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                      ]
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "chat-msg-toolbar" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.closeSession }
                    },
                    [_vm._v("关闭会话")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.sendReply }
                    },
                    [_vm._v("发送")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "chat-msg-input" },
                [
                  _c("el-input", {
                    staticClass: "reply-textarea",
                    attrs: {
                      type: "textarea",
                      rows: 6,
                      placeholder: "请输入回复内容...",
                      resize: "none"
                    },
                    on: { input: _vm.onReplyInput },
                    nativeOn: {
                      keydown: function($event) {
                        return _vm.onReplyKeydown.apply(null, arguments)
                      },
                      paste: function($event) {
                        return _vm.onReplyPaste.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.replyText,
                      callback: function($$v) {
                        _vm.replyText = $$v
                      },
                      expression: "replyText"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.showQuickReplySuggestions
                ? _c(
                    "div",
                    { staticClass: "quick-reply-suggestions" },
                    _vm._l(_vm.quickReplySuggestions, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: item.id,
                          staticClass: "suggestion-item",
                          class: {
                            active: index === _vm.selectedSuggestionIndex
                          },
                          on: {
                            click: function($event) {
                              return _vm.selectSuggestion(item)
                            },
                            mouseenter: function($event) {
                              _vm.selectedSuggestionIndex = index
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "suggestion-text" }, [
                            _vm._v("个")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "suggestion-code" }, [
                            _vm._v(_vm._s(item.quicktext))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "suggestion-content" }, [
                            _vm._v(_vm._s(item.replytext))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.settings.pageType == 1
                ? _c("el-input", {
                    staticClass: "keyword-input",
                    attrs: {
                      placeholder: "输入关键词搜索短语或编码",
                      clearable: ""
                    },
                    on: { input: _vm.onKeywordInput },
                    model: {
                      value: _vm.keyword,
                      callback: function($$v) {
                        _vm.keyword = $$v
                      },
                      expression: "keyword"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.settings.pageType == 1
                ? _c(
                    "div",
                    { staticClass: "fast-reply-content" },
                    _vm._l(_vm.filteredFastReplyList, function(g) {
                      return _c("div", { key: g.id, staticClass: "fr-group" }, [
                        _c(
                          "div",
                          {
                            staticClass: "fr-group-header",
                            on: {
                              click: function($event) {
                                return _vm.toggleGroup(g.id)
                              }
                            }
                          },
                          [
                            _c("i", {
                              class: _vm.settings.collapsedGroups[g.id]
                                ? "el-icon-caret-right"
                                : "el-icon-caret-bottom"
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "fr-group-title" }, [
                              _vm._v(
                                _vm._s(g.name) +
                                  " (" +
                                  _vm._s((g.filteredReplyList || []).length) +
                                  ")"
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.settings.collapsedGroups[g.id],
                                expression: "!settings.collapsedGroups[g.id]"
                              }
                            ],
                            staticClass: "fr-group-body"
                          },
                          _vm._l(g.filteredReplyList || [], function(r) {
                            return _c(
                              "div",
                              { key: r.id, staticClass: "fr-item" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "fr-quick",
                                    staticStyle: { "font-weight": "800" }
                                  },
                                  [_vm._v("/" + _vm._s(r.quicktext) + " |")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "fr-text",
                                    on: {
                                      click: function($event) {
                                        return _vm.onClickReply(r)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(r.replytext))]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "fr-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.menuDeleteReply(r)
                                        }
                                      }
                                    },
                                    [_vm._v("删除")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.menuEditReply(r, g)
                                        }
                                      }
                                    },
                                    [_vm._v("编辑")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.onClickReply(r)
                                        }
                                      }
                                    },
                                    [_vm._v("发送")]
                                  )
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.settings.pageType == 1
                ? _c("div", {
                    staticClass: "add-reply-btn",
                    on: { click: _vm.newFastReply }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.settings.pageType == 2 && _vm.matchedOrder
                ? _c("div", { staticClass: "orders-list" }, [
                    _c("div", { staticClass: "order-card" }, [
                      _c("div", { staticClass: "oc-head" }, [
                        _c("div", { staticClass: "oc-line1" }, [
                          _c("span", { staticClass: "oc-status" }, [
                            _vm._v(_vm._s(_vm.matchedOrder.status))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "oc-no" }, [
                            _vm._v(_vm._s(_vm.orderHeader.orderNo))
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "oc-icons" },
                            [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "bottom-start",
                                    trigger: "click",
                                    width: "320",
                                    "popper-class": "order-note-pop"
                                  },
                                  model: {
                                    value: _vm.notePopoverVisible,
                                    callback: function($$v) {
                                      _vm.notePopoverVisible = $$v
                                    },
                                    expression: "notePopoverVisible"
                                  }
                                },
                                [
                                  _c("div", { staticClass: "onp-wrap" }, [
                                    _c("div", { staticClass: "onp-head" }, [
                                      _c("span", [_vm._v("订单备注")])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "onp-flags" },
                                      [
                                        _vm._l(_vm.noteFlagColors, function(
                                          c,
                                          i
                                        ) {
                                          return _c(
                                            "label",
                                            {
                                              key: "f_" + i,
                                              staticClass: "onp-flag"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.noteFlagIndex,
                                                    expression: "noteFlagIndex"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "radio",
                                                  name: "noteFlag"
                                                },
                                                domProps: {
                                                  value: i,
                                                  checked: _vm._q(
                                                    _vm.noteFlagIndex,
                                                    i
                                                  )
                                                },
                                                on: {
                                                  change: function($event) {
                                                    _vm.noteFlagIndex = i
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "dot",
                                                style: { background: c }
                                              })
                                            ]
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          { staticClass: "onp-flag" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.noteFlagIndex,
                                                  expression: "noteFlagIndex"
                                                }
                                              ],
                                              attrs: {
                                                type: "radio",
                                                name: "noteFlag"
                                              },
                                              domProps: {
                                                value: 4,
                                                checked: _vm._q(
                                                  _vm.noteFlagIndex,
                                                  4
                                                )
                                              },
                                              on: {
                                                change: function($event) {
                                                  _vm.noteFlagIndex = 4
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "dot",
                                                staticStyle: {
                                                  "margin-top": "-12px"
                                                }
                                              },
                                              [_vm._v("🚩")]
                                            )
                                          ]
                                        )
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "onp-text" },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            rows: 5,
                                            placeholder: "请输入备注内容"
                                          },
                                          model: {
                                            value: _vm.noteText,
                                            callback: function($$v) {
                                              _vm.noteText = $$v
                                            },
                                            expression: "noteText"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "onp-check" },
                                      [
                                        _c(
                                          "el-checkbox",
                                          { attrs: { disabled: "" } },
                                          [_vm._v("自动添加暗注人和时间到末尾")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "onp-foot" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "mini"
                                            },
                                            on: { click: _vm.onNoteConfirm }
                                          },
                                          [_vm._v("确定")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { size: "mini" },
                                            on: {
                                              click: function($event) {
                                                _vm.notePopoverVisible = false
                                              }
                                            }
                                          },
                                          [_vm._v("取消")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "oc-badge",
                                      staticStyle: { cursor: "pointer" },
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v("备")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "oc-badge" }, [
                                _vm._v("详")
                              ])
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "oc-time" }, [
                          _vm._v("下单：" + _vm._s(_vm.orderHeader.orderTime))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "oc-body" }, [
                        _c("img", {
                          staticClass: "oc-img",
                          attrs: { src: _vm.matchedOrder.imgurl }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "oc-info" }, [
                          _c(
                            "div",
                            {
                              staticClass: "oc-title",
                              attrs: { title: _vm.matchedOrder.productName }
                            },
                            [_vm._v(_vm._s(_vm.matchedOrder.productName))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "oc-price" }, [
                            _vm._v("实付: "),
                            _c(
                              "span",
                              { staticStyle: { "font-weight": "700" } },
                              [
                                _vm._v(
                                  "¥ " +
                                    _vm._s(_vm.matchedOrder.price.toFixed(2))
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm._m(2),
                          _vm._v(" "),
                          _c("div", { staticClass: "oc-spec" }, [
                            _vm._v(
                              "规格：" + _vm._s(_vm.matchedOrder.size || "默认")
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "oc-code" }, [
                            _vm._v("编码：" + _vm._s(_vm.matchedOrder.id))
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(3)
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "oc-recv" }, [
                        _c("div", { staticClass: "row title" }, [
                          _vm._v("收货信息")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _vm._v(
                            _vm._s(_vm.matchedOrder.name) +
                              "  " +
                              _vm._s(_vm.matchedOrder.phone)
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _vm._v(_vm._s(_vm.matchedOrder.address))
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.matchedOrder.status == "待发货"
                        ? _c("div", { staticClass: "oc-ship" }, [
                            _vm._v("承诺发货：1天8小时48分钟54秒内发货")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "oc-foot" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("订单金额")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            "¥ " + _vm._s(_vm.matchedOrder.price.toFixed(2))
                          ),
                          _c("em", { staticClass: "ship" }, [
                            _vm._v("（含运费 ¥0.00）")
                          ])
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                staticClass: "action-order-btn",
                on: {
                  click: function($event) {
                    _vm.settings.pageType = 2
                  }
                }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "action-reply-btn",
                on: {
                  click: function($event) {
                    _vm.settings.pageType = 1
                  }
                }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "action-import-btn",
                on: {
                  click: function($event) {
                    _vm.settings.pageType = 3
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.settings.pageType == 3,
              expression: "settings.pageType == 3"
            }
          ],
          staticClass: "jm-container"
        },
        [
          _c("img", {
            staticClass: "jm-bg",
            attrs: {
              src: require("@/assets/images/jingmai/dd_fast-import.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "jm-content" }, [
            _c("div", {
              staticClass: "action-chat-btn",
              on: {
                click: function($event) {
                  _vm.settings.pageType = 1
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "fast-reply-group" }, [
              _c(
                "div",
                { staticClass: "frg-scroll" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "frg-item",
                      class: { active: _vm.settings.selectedFrgId === "all" },
                      on: { click: _vm.onSelectFrgAll }
                    },
                    [_vm._v("全部")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "frg-item frg-add",
                      on: {
                        click: function($event) {
                          _vm.settings.showGroupManage = true
                        }
                      }
                    },
                    [_vm._v("+ 新增分组")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.settings.groups, function(g) {
                    return _c(
                      "div",
                      {
                        key: g.id,
                        staticClass: "frg-item",
                        class: { active: _vm.settings.selectedFrgId === g.id },
                        on: {
                          click: function($event) {
                            return _vm.onSelectFrg(g)
                          }
                        }
                      },
                      [_vm._v(_vm._s(g.name))]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "fast-reply-toolbar" }, [
              _c("div", { staticClass: "frt-left" }, [
                _c("div", { staticClass: "frt-count" }, [
                  _vm._v("共" + _vm._s(_vm.selectedGroupReplyCount) + "条")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "frt-btn",
                    on: {
                      click: function($event) {
                        _vm.showImport = true
                      }
                    }
                  },
                  [_vm._v("批量导入")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "frt-right" }, [
                _c(
                  "div",
                  {
                    staticClass: "frt-btn",
                    on: {
                      click: function($event) {
                        _vm.settings.showGroupManage = true
                      }
                    }
                  },
                  [_vm._v("管理分组")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "frt-btn frt-btn-primary",
                    on: { click: _vm.menuAddReply }
                  },
                  [_vm._v("新建短语")]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "fast-reply-list" }, [
              _c("div", { staticClass: "fr-table" }, [
                _vm._m(4),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "fr-tbody" },
                  [
                    _vm._l(_vm.displayedReplies, function(r, i) {
                      return _c(
                        "div",
                        { key: (r.id || i) + "_row", staticClass: "fr-tr" },
                        [
                          _c("div", { staticClass: "fr-td col-index" }, [
                            _vm._v(_vm._s(i + 1))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "fr-td col-quick" }, [
                            _vm._v("/" + _vm._s(r.quicktext))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fr-td col-text",
                              attrs: { title: r.replytext }
                            },
                            [_vm._v(_vm._s(r.replytext))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "fr-td col-actions" }, [
                            _c(
                              "div",
                              {
                                staticClass: "fr-op-btn",
                                on: {
                                  click: function($event) {
                                    return _vm.menuEditReply(r, {
                                      id: _vm.settings.selectedFrgId
                                    })
                                  }
                                }
                              },
                              [_vm._v("编辑")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fr-op-btn danger",
                                on: {
                                  click: function($event) {
                                    return _vm.menuDeleteReply(r)
                                  }
                                }
                              },
                              [_vm._v("删除")]
                            )
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    !_vm.displayedReplies || _vm.displayedReplies.length === 0
                      ? _c("div", { staticClass: "fr-empty" }, [
                          _vm._v("暂无数据")
                        ])
                      : _vm._e()
                  ],
                  2
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("FastReplyImportDDDialog", {
        attrs: { sceneId: _vm.sceneId, visible: _vm.showImport },
        on: {
          "update:visible": function($event) {
            _vm.showImport = $event
          },
          refresh: _vm.refreshFastReply
        }
      }),
      _vm._v(" "),
      _c("FastReplyEditorDialog", {
        attrs: {
          showAddGroup: false,
          sceneId: _vm.sceneId,
          visible: _vm.showEditor,
          defaultGroupId: _vm.settings.defaultGroupId,
          value: _vm.editorValue
        },
        on: {
          "update:visible": function($event) {
            _vm.showEditor = $event
          },
          refresh: _vm.refreshFastReply
        }
      }),
      _vm._v(" "),
      _c("TrainScoreDialog", {
        attrs: { result: _vm.trainResult, visible: _vm.showScore },
        on: {
          "update:visible": function($event) {
            _vm.showScore = $event
          },
          onRestart: _vm.restartTrain,
          onViewResult: _vm.viewResult
        }
      }),
      _vm._v(" "),
      _c("GroupManageDialog", {
        attrs: {
          sceneId: _vm.sceneId,
          visible: _vm.settings.showGroupManage,
          groups: _vm.fastReplyList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.settings, "showGroupManage", $event)
          },
          refresh: _vm.refreshFastReply
        }
      }),
      _vm._v(" "),
      _c("CourseProductModal", {
        ref: "productModal",
        attrs: { "course-id": _vm.sceneId },
        on: {
          confirm: _vm.startTrain,
          "products-fetched": function($event) {
            _vm.hasProducts = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("实操练习疑问，或者问题反馈的途径："),
      _c("br"),
      _vm._v(" 去手机上打开淘金云客服APP→点击”消息”→进”在线技能提升培训群”反馈")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("实操练习疑问，或者问题反馈的途径："),
      _c("br"),
      _vm._v(" 去手机上打开淘金云客服APP→点击”消息”→进”在线技能提升培训群”反馈")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "oc-tags" }, [
      _c("span", [_vm._v("安心购")]),
      _c("span", [_vm._v("环保包装")]),
      _c("span", [_vm._v("运费险")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "oc-side" }, [
      _c("div", { staticClass: "oc-btns" }, [
        _c("div", { staticClass: "btn" }, [_vm._v("核对地址")]),
        _vm._v(" "),
        _c("div", { staticClass: "btn" }, [_vm._v("催付")]),
        _vm._v(" "),
        _c("div", { staticClass: "btn" }, [_vm._v("改价")]),
        _vm._v(" "),
        _c("div", { staticClass: "btn" }, [_vm._v("改地址")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fr-thead fr-tr" }, [
      _c("div", { staticClass: "fr-th col-index" }, [_vm._v("序号")]),
      _vm._v(" "),
      _c("div", { staticClass: "fr-th col-quick" }, [_vm._v("快捷短语编码")]),
      _vm._v(" "),
      _c("div", { staticClass: "fr-th col-text" }, [_vm._v("快捷短语")]),
      _vm._v(" "),
      _c("div", { staticClass: "fr-th col-actions" }, [_vm._v("操作")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f9c9ea62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9c9ea62","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/FBT/doudianChat.vue
// module id = 1752
// module chunks = 0